// The callback's business belongs to the server-side OAuth attempt. Never replace it
// with the current business selection, including on reload or a route remount.
export const GOOGLE_CLAIM_KEY = 'google_oauth_claim';
export const GOOGLE_CLAIM_CONTEXT_KEY = 'google_oauth_claim_context';

export const googleClaimBusinessId = (value) => {
  if (!['string', 'number'].includes(typeof value) || !/^\d+$/.test(String(value))) return null;
  const id = Number(value);
  return Number.isSafeInteger(id) && id > 0 ? id : null;
};

export function readGoogleClaimContext(claimToken) {
  try {
    const stored = JSON.parse(sessionStorage.getItem(GOOGLE_CLAIM_CONTEXT_KEY) || 'null');
    if (
      !claimToken ||
      sessionStorage.getItem(GOOGLE_CLAIM_KEY) !== claimToken ||
      stored?.claimToken !== claimToken
    )
      return null;
    const businessProfileId = googleClaimBusinessId(stored.businessProfileId);
    return businessProfileId ? { claimToken, businessProfileId } : null;
  } catch {
    return null;
  }
}

export function captureGoogleClaimContext(claimToken, businessId) {
  if (typeof claimToken !== 'string' || !claimToken) return null;
  try {
    const existing = readGoogleClaimContext(claimToken);
    sessionStorage.setItem(GOOGLE_CLAIM_KEY, claimToken);
    // A later URL/global selection cannot retarget this token's recorded attempt.
    if (existing) return existing;
    const businessProfileId = googleClaimBusinessId(businessId);
    sessionStorage.removeItem(GOOGLE_CLAIM_CONTEXT_KEY);
    if (!businessProfileId) return null;
    const context = { claimToken, businessProfileId };
    sessionStorage.setItem(GOOGLE_CLAIM_CONTEXT_KEY, JSON.stringify(context));
    return readGoogleClaimContext(claimToken);
  } catch {
    return null;
  }
}

export function clearGoogleClaimContext(claimToken) {
  try {
    // A late response from an old component must never erase a newer attempt.
    if (sessionStorage.getItem(GOOGLE_CLAIM_KEY) !== claimToken) return;
    sessionStorage.removeItem(GOOGLE_CLAIM_KEY);
    sessionStorage.removeItem(GOOGLE_CLAIM_CONTEXT_KEY);
  } catch {
    // The mounted page still discards its in-memory token.
  }
}
